import { render, staticRenderFns } from "./EventLocationComponent.vue?vue&type=template&id=35dff04e&scoped=true&"
import script from "./EventLocationComponent.vue?vue&type=script&lang=js&"
export * from "./EventLocationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dff04e",
  null
  
)

export default component.exports